import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import type { LineItemProps } from "./line-item";

import { LineItem } from "./line-item";

export const SubtotalLine: React.FC<Omit<LineItemProps, "label">> = props => {
  const { translator } = useAppContext();

  return (
    <LineItem
      bold_price
      data_testid="subtotal"
      label={translator.t("!checkout.summary.fees-taxes.sub-total")}
      size="lg"
      {...props}
    />
  );
};
